(() => {
 const bind=root=>{
  if(root.dataset.accessoryProductBound)return;
  root.dataset.accessoryProductBound='true';
  const data=JSON.parse(root.querySelector('[data-accessory-product-data]').textContent);
  const image=root.querySelector('[data-accessory-main-image]');
  const select=root.querySelector('[data-accessory-product-variant]');
  const price=root.querySelector('[data-accessory-product-price]');
  const add=root.querySelector('[data-accessory-product-add]');
  const money=cents=>new Intl.NumberFormat(document.documentElement.lang||'nl-NL',{style:'currency',currency:window.Shopify?.currency?.active||'EUR'}).format(cents/100);
  const showImage=(src,alt,id)=>{
   if(!image||!src)return;
   image.src=src;image.alt=alt||'';image.removeAttribute('srcset');
   const selectedPath=new URL(src,location.href).pathname;
   root.querySelectorAll('[data-accessory-photo]').forEach(button=>button.setAttribute('aria-pressed',String(new URL(button.dataset.photoSrc,location.href).pathname===selectedPath)));
  };
  const sync=()=>{
   const variant=data.find(item=>String(item.id)===select?.value);if(!variant)return;
   price.textContent=money(variant.price);add.disabled=!variant.available||variant.price<=0;
   add.textContent=add.disabled?'Tijdelijk niet beschikbaar':'In mijn winkelwagen';
   showImage(variant.image,variant.alt,variant.imageId);
   const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
  };
  select?.addEventListener('change',sync);
  root.querySelectorAll('[data-accessory-photo]').forEach(button=>button.addEventListener('click',()=>showImage(button.dataset.photoSrc,button.dataset.photoAlt,button.dataset.photoId)));
  if(image)showImage(image.getAttribute('src'),image.alt);
  const description=root.querySelector('[data-accessory-description]');
  if(description?.querySelector('h2')){
   const columns=document.createElement('div');columns.className='bb-accessory-description-columns';
   let article=null;
   for(const node of [...description.childNodes]){
    if(node.nodeType===1&&node.tagName==='H2'){article=document.createElement('article');columns.append(article);}
    if(article)article.append(node);
   }
   description.append(columns);
  }
 };
 const scan=scope=>scope.querySelectorAll('[data-accessory-product]').forEach(bind);
 scan(document);document.addEventListener('shopify:section:load',event=>scan(event.target));
})();
